'use client';

import { useAppInstalled, useIsAuth, useIsReadApp } from '@/shared/providers/user-provider/use-user';
import { usePageChecker } from '@/shared/hooks/usePageChecker';
import { useIsLoginConfirmationDone } from '@/features/login-confirmation-modal/model/hook';

export function useShouldShowAppInstallBanner() {
  const appInstalled = useAppInstalled();
  const isReadApp = useIsReadApp();
  const isAuth = useIsAuth();
  const { isCurrentPage } = usePageChecker();
  const isLoginConfirmationDone = useIsLoginConfirmationDone();

  const isInstallationGuide = isCurrentPage('/installation-guide');
  const isAppNotInstalled = appInstalled === false || appInstalled === undefined;
  const isAppNotRead = isReadApp === undefined || isReadApp === false;

  return Boolean(
    isAppNotInstalled &&
      !isInstallationGuide &&
      isAppNotRead &&
      isAuth &&
      isLoginConfirmationDone
  );
}
